import type { PropsWithChildren } from 'react';

import type { IPublicClientApplication } from '@azure/msal-browser';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

import { msalConfig } from '@/config/authConfig';

const msalInstance: IPublicClientApplication = new PublicClientApplication(msalConfig);

export const MsalContextProvider = ({ children }: PropsWithChildren) => {
  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};
